{
  "type": "object",
  "name": "Query",
  "class": "g gtr-4 gtc-1 gtr-s-3 gtc-s-2 gtr-l-2 gtc-l-3 gap",
  "definitions": [
    {
      "type": "date",
      "name": "vonbelegdatum",
      "title": "Von Datum",
      "required": true,
      "class": "gr-1 gc-1"
    },
    {
      "type": "date",
      "name": "bisbelegdatum",
      "title": "Bis Datum",
      "required": true,
      "class": "gr-2 gc-1 gr-s-1 gc-s-2"
    },
    {
      "type": "fieldOk",
      "name": "ktostammUrsache",
      "title": "Lieferant",
      "showQuery": false,
      "autoLoad": true,
      "format": "{{nummer}} - {{kurzbez}}",
      "fieldOk": "ktostamm.lieferant",
      "class": "gr-3 gc-1 gr-s-2 gc-s-1-2 gr-l-1 gc-l-3"
    },
    {
      "type": "fieldOk",
      "name": "ktostammBaustelle",
      "title": "Kostenstelle",
      "showQuery": false,
      "autoLoad": true,
      "format": "{{nummer}} - {{kurzbez}}",
      "fieldOk": "ktostamm.kunde.subnummer",
      "class": "gr-4 gc-1 gr-s-3 gc-s-1-2 gr-l-2 gc-l-1"
    }
  ]
}
